import { render, staticRenderFns } from "./five.vue?vue&type=template&id=880e4e14&"
import script from "./five.vue?vue&type=script&lang=js&"
export * from "./five.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports